import { Component, Story, Knobs } from './DocTypes';

const knobs: Knobs = {
  'colour-scheme': {
    editor: 'dropdown',
    editorOptions: ['light', 'dark', 'default', ''],
    default: '',
  },
  device: {
    editor: 'dropdown',
    editorOptions: ['mobile', 'desktop', ''],
    default: '',
  },
  disableBackgroundDismiss: {
    editor: 'checkbox',
    default: false,
  },
};

const BasicStory: Story = {
  title: 'Basic',
  description: 'A basic modal',

  coreComponent_v3: {
    html: `<tag3-simple-modal open {{...knobs}} >
  <div style='padding: 20px; display: flex; flex-direction: column;'>
    This is a very simple modal
    <tag3-simple-button data-name='close' style='margin-top: 20px;' {{colour-scheme}}>Close</tag3-simple-button>
  </div>
</tag3-simple-modal>
<tag3-simple-button data-name='open' {{colour-scheme}}>Open</tag3-simple-button>
`,
    js: `var closeButton = document.querySelector('tag3-simple-button[data-name="close"]');
closeButton.addEventListener("buttonClick", function () {
  var modal = document.querySelector('tag3-simple-modal');
  modal.open = false;
});
var openButton = document.querySelector('tag3-simple-button[data-name="open"]');
openButton.addEventListener("buttonClick", function () {
  var modal = document.querySelector('tag3-simple-modal');
  modal.open = true;
});
`,
    knobs: knobs,
  },
  reactWrapper_v3: {
    jsx: `<Example />`,
    parentJSX: `Example = () => {
  const [open, setOpen] = React.useState(true);

  return (
    <>
      <Tag3SimpleModal open={open} {{...knobs}}>
        <div style={{padding: "20px", display: "flex", flexDirection: "column"}}>
          This is a very simple modal
          <Tag3SimpleButton
            onButtonClick={() => setOpen(false)}
            style={{marginTop: "20px"}} {{colour-scheme}}
          >
            Close
          </Tag3SimpleButton>
        </div>
      </Tag3SimpleModal>
      <Tag3SimpleButton
        onButtonClick={() => setOpen(true)}
      {{colour-scheme}}>
        Open
      </Tag3SimpleButton>
    </>
  )
}
  `,
    knobs: knobs,
  },
};

const ModalInModalStory: Story = {
  title: 'Modal in modal',
  description: 'A modal within another modal',

  coreComponent_v3: {
    html: `<tag3-simple-modal open data-name='modal1'>
  <div style='width: 200px; height: 200px; padding: 20px; display: flex; flex-direction: column; justify-content: space-between; position: relative;'>
    <tag3-clickable data-name='close1' style="position: absolute; top: 2px; right: 2px;"><tag3-icon-svg icon="CrossThin"></tag3-icon-svg></tag3-clickable>
    This is the first modal
    <tag3-simple-button style='margin-top: 20px;' data-name='open2' style="display:block;">Open modal 2</tag3-simple-button>
    <tag3-simple-modal data-name='modal2'>
      <div style='width: 150px; height: 150px; padding: 20px; display: flex; flex-direction: column; justify-content: space-between; position: relative;'>
        <tag3-clickable data-name='close2' style="position: absolute; top: 2px; right: 2px;"><tag3-icon-svg icon="CrossThin"></tag3-icon-svg></tag3-clickable>
        This is the second modal
      </div>
    </tag3-simple-modal>
  </div>
</tag3-simple-modal>
<tag3-simple-button style='margin-top: 20px;' data-name='open1'>Open modal 1</tag3-simple-button>
`,
    js: `var close1 = document.querySelector('tag3-clickable[data-name="close1"]');
close1.addEventListener("buttonClick", function () {
  var modal1 = document.querySelector('tag3-simple-modal[data-name="modal1"]');
  modal1.open = false;
});
var open1 = document.querySelector('tag3-simple-button[data-name="open1"]');
open1.addEventListener("buttonClick", function () {
  var modal1 = document.querySelector('tag3-simple-modal[data-name="modal1"]');
  modal1.open = true;
});
var close2 = document.querySelector('tag3-clickable[data-name="close2"]');
close2.addEventListener("buttonClick", function () {
  var modal2 = document.querySelector('tag3-simple-modal[data-name="modal2"]');
  modal2.open = false;
});
var open2 = document.querySelector('tag3-simple-button[data-name="open2"]');
open2.addEventListener("buttonClick", function () {
  var modal2 = document.querySelector('tag3-simple-modal[data-name="modal2"]');
  modal2.open = true;
});
`,
    knobs: knobs,
  },
  reactWrapper_v3: {
    jsx: `<Example />`,
    parentJSX: `Example = () => {
  const [open1, setOpen1] = React.useState(true);
  const [open2, setOpen2] = React.useState(false);

  return (
    <>
      <Tag3SimpleModal open={open1}>
        <div style={{width: '200px', height: '200px', padding: '20px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', position: 'relative'}}>
          <Tag3Clickable
            onButtonClick={() => setOpen1(false)}
            style={{position: 'absolute', top: '2px', right: '2px'}}>
            <Tag3IconSvg icon="CrossThin"></Tag3IconSvg>
          </Tag3Clickable>
          This is the first modal
          <Tag3SimpleButton
            onButtonClick={() => setOpen2(true)}
            style={{marginTop: '20px'}}>
            Open modal 2
          </Tag3SimpleButton>
          <Tag3SimpleModal open={open2}>
            <div style={{width: '150px', height: '150px', padding: '20px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', position: 'relative'}}>
              <Tag3Clickable
                onButtonClick={() => setOpen2(false)}
                style={{position: 'absolute', top: '2px', right: '2px'}}>
                <Tag3IconSvg icon="CrossThin"></Tag3IconSvg>
              </Tag3Clickable>
              This is the second modal
            </div>
          </Tag3SimpleModal>
        </div>
      </Tag3SimpleModal>
      <Tag3SimpleButton
        onButtonClick={() => setOpen1(true)}
        style={{marginTop: '20px'}}>
        Open modal 1
      </Tag3SimpleButton>
    </>
  )
}
  `,
    knobs: knobs,
  },
};

const InvalidFieldBehindModalStory: Story = {
  title: 'Invalid field behind modal',
  description: 'An invalid field behind a modal',

  coreComponent_v3: {
    html: `<div>
  <tag3-input placeholder='Enter something' class='some-input' style='width: 200px;'></tag3-input>
  <tag3-validator source-element='.some-input' source-element-value-prop='value' trigger-element-event='focusout' rule='required' error-element='.some-input-error'></tag3-validator>
  <tag3-validation-alert class='some-input-error'>You must enter something</tag3-validation-alert>
</div>
<div style='margin-top: 10px;'>
  <tag3-simple-button data-name='open'>Open modal</tag3-simple-button>
</div>
<tag3-simple-modal>
  <div style='width: 800px; height: 200px; padding: 20px; display: flex; flex-direction: column;'>
    This should overlay the field and any validation message
    <tag3-simple-button data-name='close' style='margin-top: 20px;'>Close</tag3-simple-button>
  </div>
</tag3-simple-modal>
`,
    js: `var closeButton = document.querySelector('tag3-simple-button[data-name="close"]');
closeButton.addEventListener("buttonClick", function () {
  var modal = document.querySelector('tag3-simple-modal');
  modal.open = false;
});
var openButton = document.querySelector('tag3-simple-button[data-name="open"]');
openButton.addEventListener("buttonClick", function () {
  var modal = document.querySelector('tag3-simple-modal');
  modal.open = true;
});
`,
  },
  reactWrapper_v3: {
    jsx: `<Example />`,
    parentJSX: `Example = () => {
  const [open, setOpen] = React.useState(false);

  return (
    <>
      <div>
        <Tag3Input placeholder='Enter something' className='some-input' style={{width: "200px"}}></Tag3Input>
        <Tag3Validator source-element='.some-input' source-element-value-prop='value' trigger-element-event='focusout' rule='required' error-element='.some-input-error'></Tag3Validator>
        <Tag3ValidationAlert className='some-input-error'>You must enter something</Tag3ValidationAlert>
      </div>
      <div style={{marginTop: "10px"}}>
        <Tag3SimpleButton onButtonClick={() => setOpen(true)}>Open modal</Tag3SimpleButton>
      </div>
      <Tag3SimpleModal open={open}>
        <div style={{width: "800px", height: "200px", padding: "20px", display: "flex", flexDirection: "column"}}>
        This should overlay the field and any validation message
          <Tag3SimpleButton
            onButtonClick={() => setOpen(false)}
            style={{marginTop: "20px"}} 
          >
            Close
          </Tag3SimpleButton>
        </div>
      </Tag3SimpleModal>
    </>
  )
}
  `,
  },
};

export const TagSimpleModalDocs: Component = {
  type: 'component',
  name: 'simple-modal',
  description: 'Renders a modal dialog that gives you full control of the content.',
  mobileFriendly: false,
  popular: false,
  preRelease: '',
  props: [
    {
      name: 'open',
      description: 'Whether the modal is open',
      type: 'boolean',
    },
    {
      name: 'modalAriaLabel',
      description: 'A title for screen readers',
      type: 'string',
    },
    {
      name: 'modalAriaLabelledBy',
      description: 'An id of the title element for screen readers (alternative for modalAriaLabel)',
      type: 'string',
    },
    {
      name: 'modalAriaDescribedBy',
      description: 'An id of the description element for screen readers',
      type: 'string',
    },
    {
      name: 'colour-scheme',
      description:
        'Dark mode (theme) control. Default for normal browser driven control. Dark | Light to force respective styling regardless of browser setting.',
      type: 'dark | light | default',
      default: 'light',
    },
    {
      name: 'device',
      description: 'Set preferred styling theme for device type.',
      type: 'desktop | mobile',
      default: 'desktop',
    },
    {
      name: 'disable-background-dismiss',
      description: 'Set whether the modal will dismiss when you click on the background overlay',
      type: 'boolean',
      default: 'false',
    },
  ],
  reactPropOverrides: [],
  events: [
    {
      name: 'openChange',
      description: 'Raised when the modal is opened / closed',
      parameters: [
        {
          name: 'open',
          description: 'Whether the modal is open',
          type: 'boolean',
        },
      ],
    },
  ],
  methods: [],
  stories: [BasicStory, ModalInModalStory, InvalidFieldBehindModalStory],
};
